/*
 * @Description: 租户管理--租户地域管理
 * @Author: zhaoqing
 * @LastEditors: pu.yuchun
 * @Date: 2019-7-10
 * @LastEditTime: 2019-09-17 16:37:02
 */
'use strict';
angular.module('regionManageModule', []).controller('regionManageCtrl', [
    '$scope',
    'trsspliceString',
    '$q',
    '$filter',
    'tManageMentService',
    'modalDialog',
    'trsHttpService',
    '$validation',
    function(
        $scope,
        trsspliceString,
        $q,
        $filter,
        tManageMentService,
        modalDialog,
        trsHttpService,
        $validation
    ) {
        // token 租户id
        var token = '',
            tenantId = '';

        // tree 组件配置
        $scope.expanded = [];
        $scope.selectedNode = {
            // moduleName: '',
            // moduleDesc: '',
            // moduleId: ''
        };
        $scope.dataForTheTree = [];
        $scope.treeOptions = {
            nodeChildren: 'childlist',
            dirSelectable: true,
            allowDeselect: false,
            injectClasses: {
                ul: 'a1 manage-tree',
                li: 'a2',
                liSelected: 'a7',
                iExpanded: 'icon-previewright a3',
                iCollapsed: 'icon-previewright a4',
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'rolegrouplabselected'
            },
            isLeaf: function(node) {
                return !node.childlist || !node.childlist.length;
            }
        };

        // 表单
        $scope.editNode = {};
        // 是否是新建节点状态
        $scope.isAddNode = false;
        // 表单验证
        // $scope.validate = true;

        // 清空表单数据
        // function resetForm(obj) {
        //     for(var key in obj) {
        //         if(obj.hasOwnProperty(key)) obj[key] = '';
        //     }
        // }

        // 获取树节点
        function getTreeData() {
            $scope.loadingPromise = trsHttpService
                .httpServer(
                    '/api/tenantcenter/region/getRegionList',
                    {},
                    'get',
                    '',
                    { token: token }
                )
                .then(function(data) {
                    function addId(list, id) {
                        list.forEach(function(item) {
                            if (id) item.parentId = id;
                            item.childlist &&
                                item.childlist.length &&
                                (item.childlist = addId(
                                    item.childlist,
                                    item.id
                                ));
                        });
                        return list;
                    }
                    $scope.dataForTheTree = addId(data.datas);
                    console.log($scope.dataForTheTre);
                });
        }

        // 获取当前登录人的信息 获取token
        function getCurrentInfo() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getCurrUserInfo'
            };
            $scope.loadingPromise = trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get', '', {
                    token: token
                })
                .then(function(data) {
                    if (data.TENANTID) {
                        tenantId = data.TENANTID;
                        getToken(deffer.resolve);
                    }
                });
            return deffer.promise;
        }

        // 获取登录token
        function getToken(resolve) {
            var params = {
                serviceid: 'getToken',
                tenantId: tenantId
            };
            $scope.loadingPromise = trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get', '', {
                    token: token
                })
                .then(function(data) {
                    if (data.token) {
                        token = data.token;
                        resolve();
                    }
                });
        }

        // 获取 token 后 ，请求树节点
        getCurrentInfo().then(function() {
            getTreeData();
        });

        $scope.showToggle = function() {
            // console.log('toggle')
            // console.log(arguments)
        };

        $scope.showSelected = function(node) {
            // console.log('show');
            // console.log(arguments);
            $scope.isAddNode = false;
            $scope.selectedNode = node;
            $scope.editNode = {
                content: node.content,
                dictName: node.dictname,
                dictNum: node.dictnum,
                orderNum: node.ordernum,
                // section: node.section,
                // type: node.type,
                id: node.id,
                regionId: node.regionid
            };
        };

        // 保存
        $scope.saveNode = function() {
            $validation
                .validate($scope.createRegionModule)
                .success(function() {
                    if ($scope.isAddNode) {
                        $scope.editNode.parentId = $scope.editNode.root
                            ? ''
                            : $scope.editNode.regionId;
                        delete $scope.editNode.root;
                        delete $scope.editNode.regionId;
                    }
                    console.log($scope.editNode);
                    $scope.loadingPromise = trsHttpService
                        .httpServer(
                            '/api/tenantcenter/region/saveOrUpdate',
                            $scope.editNode,
                            'post',
                            '',
                            { token: token }
                        )
                        .then(function(data) {
                            console.log(data);
                            if (data.code === '200') {
                                modalDialog.saveModel(
                                    '提示',
                                    '保存成功',
                                    'success',
                                    false
                                );
                                getTreeData();
                                if ($scope.isAddNode) {
                                    $scope.addNode('isRoot');
                                }
                            } else {
                                modalDialog.alertType(
                                    '提示',
                                    data.msg || '保存失败',
                                    'error',
                                    'confirm',
                                    function() {}
                                );
                            }
                        });
                })
                .error(function() {
                    modalDialog.alertType(
                        '请检查填写项!',
                        '',
                        'warning',
                        false
                    );
                });
        };

        // 新建节点
        $scope.addNode = function(isRoot) {
            $scope.isAddNode = true;
            $scope.editNode = {
                regionId: $scope.editNode.regionId,
                root: !!isRoot,
                content: '',
                dictName: '',
                dictNum: '',
                orderNum: '',
                // section: '',
                // type: '',
                id: ''
            };
            $scope.createRegionModule.$setPristine();
        };

        // 删除节点
        $scope.deleteNode = function() {
            modalDialog.alertType(
                '确定删除？',
                '',
                'info',
                true,
                function() {
                    deleteNodeFn();
                },
                function() {}
            );
        };
        // 删除操作
        function deleteNodeFn() {
            var params = {
                regionId: $scope.editNode.regionId
            };
            $scope.loadingPromise = trsHttpService
                .httpServer(
                    '/api/tenantcenter/region/delRegion',
                    params,
                    'post',
                    '',
                    {
                        token: token
                    }
                )
                .then(function(data) {
                    console.log(data);
                    if (data.code === '200') {
                        modalDialog.saveModel(
                            '提示',
                            '删除成功',
                            'success',
                            false
                        );
                        getTreeData();
                        $scope.selectedNode = {};
                        $scope.editNode = {};
                        $scope.createRegionModule.$setPristine();
                    } else {
                        modalDialog.alertType(
                            '提示',
                            data.msg || '删除失败',
                            'error',
                            'confirm',
                            function() {}
                        );
                    }
                });
        }

        // 表单验证
        // function isEmpty(fileds) {
        //     return fileds === undefined || fileds.replace(/(^\s*)|(\s*$)/g, "") === '';
        // }

        return false;
    }
]);
